import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=013b0b4c&scoped=true"
import script from "./Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Policy.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Policy.vue?vue&type=style&index=0&id=013b0b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b0b4c",
  null
  
)

export default component.exports